import { axiosClient } from "./axiosClient"

export const CUSTOMER_PATH = '/api/v1/customer'

export const addCustomer = (body) => {
    return axiosClient.post(CUSTOMER_PATH, body)
}

export const updateCustomer = (id, body) => {
    return axiosClient.put(`${CUSTOMER_PATH}/${id}`, body)
}

export const deleteCustomer = (id) => {
    return axiosClient.delete(`${CUSTOMER_PATH}/${id}`)
}

export const getCustomerById = (id) => {
    return axiosClient.get(`${CUSTOMER_PATH}/${id}`)
}

export const getPageCustomers = ({ search = "", lastId = '', id = "", code = '', name = '', showOnlyMarked = false }) => {
    return axiosClient.get(`${CUSTOMER_PATH}/page?search=${search}&lastId=${lastId}&id=${id}&code=${code}&name=${name}&showOnlyMarked=${showOnlyMarked}`)
}

export const uploadCustomerExcelFile = (body) => {
    return axiosClient.post(`${CUSTOMER_PATH}/upload-excel`, body)
}

export const downloadCustomerExcelFile = () => {
    return axiosClient.get(`${CUSTOMER_PATH}/download-excel`, {
        responseType: 'arraybuffer',
    })
}

export const downloadCustomerReceipt = (id, firstDate, lastDate) => {
    return axiosClient.get(`${CUSTOMER_PATH}/receipt/${id}?firstDate=${firstDate}&lastDate=${lastDate}`, {
        responseType: 'arraybuffer',
    })
}

export const downloadDetailedCustomerReceipt = (id, firstDate, lastDate) => {
    return axiosClient.get(`${CUSTOMER_PATH}/detailed-receipt/${id}?firstDate=${firstDate}&lastDate=${lastDate}`, {
        responseType: 'arraybuffer',
    })
}

export const downloadCustomerReceipts = (currency) => {
    return axiosClient.get(`${CUSTOMER_PATH}/receipts?currency=${currency}`, {
        responseType: 'arraybuffer',
    })
}

export const toggleCustomerMark = (id) => {
    return axiosClient.put(`${CUSTOMER_PATH}/toggle-mark/${id}`)
}
